import { ERROR_CODES } from "../constants/errors";

export const formatApiError = (errObj) => {
  if (
    errObj?.error === ERROR_CODES.MULTIPLE_ERRORS &&
    Array.isArray(errObj.data?.errors)
  ) {
    const tail = errObj.data.errors.map((e) => e.message).join(" | ");
    return `${errObj.message}: ${tail}`;
  }
  return errObj?.message || "Unexpected error.";
};

/**
 * Formats various error types into a standardized error object.
 * This is the single source of truth for formatting errors from the API layer.
 * @param {Error} error - The error object from Axios.
 * @param {string} functionName - Name of the calling function for logging.
 * @returns {object} Standardized error object { status: false, code: string, message: string }.
 */
export const formatFirebaseError = (error, functionName) => {
    console.error(`[API Layer/${functionName}] Error:`, error);

    if (error && error.code && typeof error.code === 'string' && error.code.startsWith('auth/')) {
        console.log(`[ErrorFormatter/${functionName}] Identified as Firebase SDK Error.`);
        return {
            status: false,
            code: error.code, // e.g., 'auth/network-request-failed'
            message: error.message || 'A Firebase authentication error occurred.'
        };
    }
    else {
      console.log(`[ErrorFormatter/${functionName}] Identified as non Firebase SDK Error.`);
      return {
            status: false,
            code: error.code, // e.g., 'auth/network-request-failed'
            message: error.message || 'A non Firebase authentication error occurred.'
        };
    }
};